import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink as BaseNavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { styled, theme } from "../theme";
export const NavLink = (props) => (_jsx(StyledNavLink, { ...props }));
NavLink.propTypes = {
    activeStyle: PropTypes.shape({
        fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        color: PropTypes.string,
        textDecoration: PropTypes.string,
    }),
};
NavLink.defaultProps = {
    activeStyle: {
        fontWeight: theme.fontWeight.bold,
    },
};
const StyledNavLink = styled(BaseNavLink) `
  text-decoration: none;
  line-height: 1.75em;
  color: ${({ theme }) => theme.color.darkBlue100};
  display: inline-block;
  margin-left: 35px;

  @media (max-width: 768px) {
    margin-left: 15px;
  }

  &:hover {
    color: ${({ theme }) => theme.color.primary};
  }
`;
